import React, { FunctionComponent } from 'react';
import {
	VerticalDivider,
	SmallOMRWrapper,
	ArrowIconContainer,
	PriceContentWrapper,
	PriceBlockContainer,
	VatWrapper,
	PriceAccordion,
	PriceHeaderWrapper,
	PriceIconWrapper,
	PriceTagWrapper,
	PriceContentRowWrapper,
	PriceDetailsWrapper,
} from './ProductCartCard.styled';

import ConditionalRender from '@Components/ConditionalRender/ConditionalRender';
import { useSelector } from 'react-redux';
import Icon from '@Components/Icon/Icon';

import {
	BodyMBold,
	BodyS,
	BodySBold,
	CaptionBigger,
	Info,
	InfoBold,
	ParagraphSBold,
} from '@Components/Typography/Typography.styled';
import { roundMoney } from '@Utils/converters/roundMoney';
import useTranslate from '@Utils/hooks/useTranslate';
import useScreen from '@Utils/hooks/useScreen';

const ICON_SIZE = 24;
const ICON_SIZE_40 = 40;
const WARNING_ICON_SIZE = 35;
const ADD_TO_CART_BI = 'ADD_TO_CART_BI';
const DEF_COLOR = 'DEF_Color';
const DEF_CAPACITY = 'DEF_Capacity';
const BNPL_PLAN_ACTIONS = ['BNPL_BAQATI', 'BNPL_HBB', 'BNPL_WFBB'];
interface INamaCartCard {
	showFullUpfront: boolean;
	showFullMonthly: boolean;
	setShowFullUpfront: (type: boolean) => void;
	setShowFullMonthly: (type: boolean) => void;
	isSmartVoucher: boolean;
}
const NamaCartCard: FunctionComponent<INamaCartCard> = ({
	showFullUpfront,
	setShowFullUpfront,
	showFullMonthly,
	setShowFullMonthly,
	isSmartVoucher = false,
}) => {
	const selectedProduct = useSelector((state: types.redux.IState) => state.selectedItems?.details);
	const { translate } = useTranslate();
	const { screen } = useScreen();
	const showColor = (): boolean => {
		return !!selectedProduct?.attributes.find((item) => item.identifier === DEF_COLOR)?.values[0].value;
	};
	const getColor = (): string => {
		return `${selectedProduct?.attributes.find((item) => item.identifier === DEF_COLOR)?.values[0].value}, `;
	};
	return (
		<PriceBlockContainer>
			<PriceAccordion onClick={() => setShowFullUpfront(!showFullUpfront)}>
				<PriceHeaderWrapper>
					<PriceIconWrapper>
						<ArrowIconContainer isShowFull={showFullUpfront}>
							<Icon name="arrowDown" fill="black" />
						</ArrowIconContainer>
						<ConditionalRender
							show={screen('lg')}
							onTrue={() => <ParagraphSBold>{translate('product.cart-card.upfront')}</ParagraphSBold>}
							onFalse={() => <BodyMBold>{translate('product.cart-card.upfront')}</BodyMBold>}
						/>
					</PriceIconWrapper>
					<PriceTagWrapper>
						<SmallOMRWrapper>{translate('omr')}</SmallOMRWrapper>
						<BodyMBold>{roundMoney(selectedProduct?.priceDisplay ?? 0)}</BodyMBold>
					</PriceTagWrapper>
				</PriceHeaderWrapper>{' '}
			</PriceAccordion>
			<ConditionalRender
				show={showFullUpfront}
				onTrue={() => (
					<PriceContentWrapper isShown={showFullUpfront}>
						<PriceContentRowWrapper isBottomMode={true}>
							<VerticalDivider />
							<PriceDetailsWrapper>
								<BodyS>{selectedProduct?.name}</BodyS>
								<CaptionBigger>
									<ConditionalRender show={showColor()} onTrue={() => <>{getColor()}</>} />
									{
										selectedProduct?.attributes.find((item) => item.identifier === DEF_CAPACITY)
											?.values[0].value
									}
								</CaptionBigger>
								<BodySBold>
									{`${translate('omr')} ${roundMoney(selectedProduct?.priceDisplay ?? 0)}`}
								</BodySBold>
							</PriceDetailsWrapper>
						</PriceContentRowWrapper>
						{isSmartVoucher && (
							<PriceContentRowWrapper isBottomMode={true}>
								<VerticalDivider />
								<PriceDetailsWrapper>
									<BodySBold>
										{`${translate('omr')} ${roundMoney(
											selectedProduct?.pricesWithVat.vatValue ?? 0
										)}`}
									</BodySBold>
								</PriceDetailsWrapper>
							</PriceContentRowWrapper>
						)}
					</PriceContentWrapper>
				)}
			/>
			<ConditionalRender
				show={selectedProduct?.installmentPeriod === '24' || selectedProduct?.installmentPeriod === '12'}
				onTrue={() => (
					<>
						<PriceAccordion onClick={() => setShowFullMonthly(!showFullMonthly)}>
							<PriceHeaderWrapper>
								<PriceIconWrapper>
									<ArrowIconContainer isShowFull={showFullMonthly}>
										<Icon name="arrowDown" fill="black" />
									</ArrowIconContainer>
									<ConditionalRender
										show={screen('lg')}
										onTrue={() => (
											<ParagraphSBold>
												{translate(
													`product.cart-card.for${selectedProduct?.installmentPeriod}months`
												)}
											</ParagraphSBold>
										)}
										onFalse={() => (
											<BodyMBold>
												{translate(
													`product.cart-card.for${selectedProduct?.installmentPeriod}months`
												)}
											</BodyMBold>
										)}
									/>
								</PriceIconWrapper>
								<PriceTagWrapper>
									<SmallOMRWrapper>{translate('omr')}</SmallOMRWrapper>
									<BodyMBold>{roundMoney(selectedProduct?.installmentValue ?? 0)}</BodyMBold>
								</PriceTagWrapper>
							</PriceHeaderWrapper>
							<VatWrapper>
								<Info color="black54">
									{translate('product.cart-card.with-vat', selectedProduct?.vatPercent ?? 0)}
								</Info>
								<InfoBold color="black54">
									{`${translate('omr')} ${roundMoney(
										!isSmartVoucher
											? selectedProduct?.installmentValue
											: selectedProduct?.priceOffer ?? 0
									)}`}
								</InfoBold>
							</VatWrapper>
						</PriceAccordion>
						<ConditionalRender
							show={showFullMonthly}
							onTrue={() => (
								<PriceContentWrapper isShown={showFullMonthly}>
									<PriceContentRowWrapper isBottomMode={true}>
										<VerticalDivider />
										<PriceDetailsWrapper>
											<BodyS>{selectedProduct?.name}</BodyS>
											<CaptionBigger>
												<ConditionalRender
													show={showColor()}
													onTrue={() => <>{getColor()}</>}
												/>
												{
													selectedProduct?.attributes.find(
														(item) => item.identifier === DEF_CAPACITY
													)?.values[0].value
												}
											</CaptionBigger>
											<BodySBold>
												{`${translate('omr')} ${roundMoney(
													selectedProduct?.installmentValue ?? 0
												)}`}
											</BodySBold>
										</PriceDetailsWrapper>
									</PriceContentRowWrapper>
								</PriceContentWrapper>
							)}
						/>
					</>
				)}
			/>
		</PriceBlockContainer>
	);
};
export default NamaCartCard;
